// CANONICAL COPY (GH #7115). src/constants/obligations/obl-email-security.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-email-security',
  title: 'Verify email security and anti-phishing controls',
  description:
    "Confirm that email services are protected against phishing, spoofing and malicious content (CIS v8 Control 9). Sender-authentication mechanisms — SPF, DKIM and a DMARC enforcement policy — shall be configured for the organization's domains; inbound email shall be filtered for malicious attachments and links with unnecessary or high-risk file types blocked; email server anti-malware protections shall be deployed and maintained; and only fully supported email clients and authorised extensions shall be permitted. Review the email security standard and supporting configuration evidence (e.g. DMARC record, gateway policy).",
  category: 'technical',
  scfIds: ['SCF-OPS-013'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Email security standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
